import React, {useEffect, useState} from "react"
import Form from "react-bootstrap/Form"
import Label from "../../Utils/FormInputs/Label"
import TextField from "../../Utils/FormInputs/TextField";
import {ErrorMessage, RightAlignedContainer} from "../../Utils/styledComponents";
import Textarea from "../../Utils/FormInputs/Textarea";
import SelectInput, {CustomSelect} from "../../Utils/FormInputs/SelectInput";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import {dateConvert} from "../../Utils/ConvertDate";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {history} from "../../../Helpers/history";
import {makeStyles} from "@material-ui/core/styles";
import {AccountingDrawer} from "../../Utils/AccountingUtils/AccountingDrawer";
import {useCurrency} from "../../../Context/currency-context";


const useStyles = makeStyles((theme) => ({
    drawerWidth:{
        width: 800,
        padding:'16px'
    }
}));


function RecordSupplierPayment({actions, openDialog, setOpenDialog, isSubmitted,setIsSubmitted,supplierDetails}){
    const {currency:selectedCurrency} = useCurrency({actions, openDialog, setOpenDialog, isSubmitted,setIsSubmitted,supplierDetails})

    const classes = useStyles()
    const [state, setState] = useState({payment_method:'', payment_date:dateConvert()})
    const [isFull, setIsFull] = useState(false)
    const [amountPaid, setAmountPaid] = useState(0)
    const [submitted, setSubmitted] = useState(false)
    const [memo, setMemo] = useState('');
    const [accounts, setAccounts] = useState([])
    const [paid_through, setPaidThrough] = useState('')
    const [currencies, setCurrencies] = useState([])
    const [currency, setCurrency] = useState(0)
    const [currencyExchangeRate, setCurrencyExchangeRate] = useState('')
    const [exchangeRate, setExchangeRate] = useState('')
    const [amount, setAmount] = useState({sspAmount:0, usdAmount:0})

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = _token.user_roles_id ? _token.user_roles_id : '';



    const isBase = currency ?  currency?.split('-')[1] : ''
    const isNotBase = isBase === 'false'
    const isBaseCurrency = isBase === 'true'
    const currency_symbol = currency ?  currency?.split('-')[2] : ''

    // get currencies
    useEffect(() => {
        axios
            .get(`${config.smsUrl}/accounting/currencies`)
            .then((res) => {
                const data = res.data;
                const all_data = !data ? {} : data;
                const arr = all_data.data ?? [];
                const list = arr.map((item) => ({
                    value: `${item.id}-${item.is_base_currency}-${item.currency_symbol}`,
                    text: `${item.currency_symbol} ${item.currency_name}`,
                }));
                setCurrencies(list);
            })
            .catch((err) => {
                logoutErrorMessage(err, null, actions);
            });
    }, []);


    useEffect(() => {
        axios.get(`${config.smsUrl}/accounting/ledgers_under_category`).then(res => {
            const data = res.data;
            const dt = data ? data : {};
            const arr = dt.data ? dt.data : []
            const list = arr.map(item => ({
                value: item.id,
                label: item.head_name
            }))
            setAccounts(list)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }, [])


    useEffect(() => {

        const exchange_rate = supplierDetails.currency_rate ? supplierDetails.currency_rate : 0;


        const ex_rate = Math.pow(exchange_rate, -1)
        setExchangeRate(exchange_rate)
        setCurrencyExchangeRate(ex_rate)
        setCurrency(`${supplierDetails?.currency_id}-${supplierDetails?.is_base_currency}-${supplierDetails.currency}`)
        multiplyCurrency(exchange_rate, supplierDetails?.grand_total, `${supplierDetails.is_base_currency}`)
    }, [supplierDetails]);

    const multiplyCurrency = (exchange_rate, receivedAmount, displayedCurrency) => {


        let [amountInUSD, amountInSSP] = [0,0];



        // currency is USD
        if(displayedCurrency.includes("true")){
            amountInUSD = receivedAmount
            amountInSSP = Number(exchange_rate) <= 0 ? 0 : Number(exchange_rate) * Number(receivedAmount)
            setAmount({sspAmount: Number(amountInSSP).toFixed(4), usdAmount: Number(amountInUSD).toFixed(4)})
            return;
        }

        // currency is SSP
        if(displayedCurrency.includes("false")){
            amountInUSD = receivedAmount

            amountInSSP = Number(exchange_rate) <= 0 ? 0  :
                (Number(receivedAmount) === 0 ? 0 : Number(receivedAmount) / Number(exchange_rate));

            setAmount({sspAmount: Number(amountInSSP).toFixed(4), usdAmount: Number(amountInUSD).toFixed(4)})
            return;
        }


    }


    const handleChangeCurrency = (event) => {
        setCurrency(event.target.value);
        // setExchangeRate(0)
        setIsFull(false)
        setAmountPaid(0)

    };

    //Change exchange rate
    const handleChangeExchangeRate = (event) => {
        const ex_rate = +event.target.value > 0 ? 1 / +event.target.value : 0
        setExchangeRate(ex_rate);
        setCurrencyExchangeRate(event.target.value)
        multiplyCurrency(ex_rate,supplierDetails?.grand_total, currency);
        setIsFull(false)
        setAmountPaid(0)
    }
    const handleChangeMemo = (event) => {
        setMemo(event.target.value);
    }


    const handleCloseDialog = () =>{
        setOpenDialog(false);
    }

    const handleChange = (event) =>{
        const {name, value} = event.target;
        setState({...state, [name]:value})
        setExchangeRate(0)
        setCurrencyExchangeRate('')
        setAmount({sspAmount: 0, usdAmount: 0})
        setIsFull(false)
        setAmountPaid(0)
    }

    const handleIsFullBill = (event) =>{
        setIsFull(event.target.checked)

        const total_amount = isBaseCurrency ? amount.usdAmount : amount.sspAmount
        const full_amount = event.target.checked ? total_amount : ''
        setAmountPaid(full_amount)
        // multiplyCurrency(exchangeRate, full_amount, currency);

    }
    const handleChangeAmountPaid = (event) =>{
        setAmountPaid(event.target.value)
        // multiplyCurrency(exchangeRate, event.target.value, currency);
    }


    const handleChangePaidThrough = (val) =>{
        setPaidThrough(val)
    }

    const totalAmount = isBaseCurrency ? amount.usdAmount : amount.sspAmount

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitted(true);

        const currency_id = currency.split('-')[0]

        const is_base = currency.split('-')[1]
        const isBase = is_base === 'true'

        const amount_paid = isBase ? amountPaid : +amountPaid * +exchangeRate


        if (amountPaid && amountPaid === totalAmount  && paid_through) {

            const params = {
                payable_id: +supplierDetails?.invoice_no,
                amount_paid:+amount_paid,
                user_id:user_roles_id,
                memo,
                credit_ledger: paid_through?.value,
                currency: Number(currency_id),
                currency_rate: Number(exchangeRate),
                payment_date: state.payment_date
            }

            setIsSubmitted('pending')
            axios.post(`${config.smsUrl}/csupplier/supplier_payables/payment`, params).then(() => {
                actions.snackbarActions.snackSuccess('Payment made successfully')
                setIsSubmitted('resolved')
                setSubmitted(false)
                setOpenDialog(false)
                setAmountPaid(0)
                setIsFull(false)
                setPaidThrough(null)
                history.push('/creditors/report')
            }).catch(err => {
                errorMessages(err, null, actions)
                setIsSubmitted('rejected')
            })
        }
    }


    const isPending = isSubmitted === 'pending';

    const {payment_date} = state




    const isFullSpan = (
        <span>Pay full amount(<strong>{isNotBase ? amount.sspAmount : amount.usdAmount}</strong>)</span>
    )
    return (
        <AccountingDrawer open={openDialog} title={`Payment for ${supplierDetails?.chalan_no}`} handleClose={handleCloseDialog} width={classes.drawerWidth}>
            <form onSubmit={handleSubmit}>
                <div className='row mb-3'>
                    <div className='col-lg-8'>
                        <Form.Group>
                            <Label name='Payment Date' type/>
                            <TextField type='date' value={payment_date} name='payment_date' submitted={submitted} onChange={handleChange}/>
                            {submitted && !payment_date ? <div className='help-block'>Payment date is required</div>:null}
                        </Form.Group>

                        <Form.Group >
                            <Label name="Currency" type htmlFor="currency"/>


                            <SelectInput
                                testId='currency'
                                submitted={submitted}
                                value={currency}
                                onChange={handleChangeCurrency}
                                options={currencies}
                                id="currency"
                                defaultOption="Select..."
                            />


                        </Form.Group>

                        {
                            isNotBase ?

                                <Form.Group>
                                    <Label  name="Exchange Rate" htmlFor="exchange_rate"/>
                                    <InputGroup className="">
                                        <InputGroup.Text style={{borderRadius:'0.7rem 0 0 0.7rem'}} id="basic-addon1">{currency_symbol}</InputGroup.Text>

                                        <TextField id='exchange_rate' type="number"  value={currencyExchangeRate} onChange={handleChangeExchangeRate}/>
                                    </InputGroup>

                                    <span style={{marginTop:'5px', display:'inline-block', fontWeight:700, color:'blue'}}>(1 {selectedCurrency.currency_symbol} = {currencyExchangeRate} {currency.split('-')[2]})</span>
                                </Form.Group>
                                :
                                null
                        }

                        {currency && currencyExchangeRate && isNotBase ? <Form.Group >
                                <Label name="Total Bill"/>
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text style={{borderRadius:'0.7rem 0 0 0.7rem'}} id="basic-addon1">{selectedCurrency.currency_symbol}</InputGroup.Text>

                                            <TextField name='outstanding_amount' type="text" value={amount.usdAmount ? amount.usdAmount : 0} readOnly/>
                                        </InputGroup>
                                    </Col>

                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text style={{borderRadius:'0.7rem 0 0 0.7rem'}} id="basic-addon1">{currency_symbol}</InputGroup.Text>

                                            <TextField name='sspAmount' type="text" value={amount.sspAmount ? amount.sspAmount : 0} readOnly/>
                                        </InputGroup>
                                    </Col>
                                </Row>

                            </Form.Group>:
                            <Form.Group>
                                <Label name='Total Bill'  htmlFor='total_usd_bill'/>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text style={{borderRadius:'0.7rem 0 0 0.7rem'}} id="basic-addon1">{currency_symbol}</InputGroup.Text>

                                    <TextField name='outstanding_amount' type="text" value={amount.usdAmount ? amount.usdAmount : 0} readOnly/>
                                </InputGroup>
                            </Form.Group>}

                        <Form.Group>
                            <Label name='Amount Paid' type htmlFor='amount_paid'/>
                            <TextField type='number' id='amount_paid' value={amountPaid} submitted={submitted} onChange={handleChangeAmountPaid}/>
                            {submitted && !amountPaid ? <ErrorMessage>Amount paid is required</ErrorMessage>:
                                submitted && amountPaid !== totalAmount ? <ErrorMessage>Please enter full amount</ErrorMessage> :null}
                            <div className='mt-2'>
                                <Form.Check checked={isFull} onChange={handleIsFullBill} label={isFullSpan} data-testid="pay-full-amount"/>
                            </div>

                        </Form.Group>


                        <Form.Group>
                            <Label name='Paid through' type/>
                            <CustomSelect id='credit_to' submitted={submitted} onChange={handleChangePaidThrough} value={paid_through} options={accounts}/>
                            {submitted && !paid_through ? <ErrorMessage>Debit account is required</ErrorMessage>:null}
                        </Form.Group>

                        <Form.Group>
                            <Label name='Memo'/>
                            <Textarea rows='3' cols='3'  name="memo" onChange={handleChangeMemo} value={memo}/>
                        </Form.Group>

                        <RightAlignedContainer>
                            <button type='submit' disabled={isPending} className='btn btn-sm sms-btn'>{isPending ? 'Submitting....' : 'Submit'}</button>
                        </RightAlignedContainer>
                    </div>

                    <div className='col-lg-4'>
                    </div>
                </div>
            </form>
        </AccountingDrawer>
    )
}

export {RecordSupplierPayment}